var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSuccessIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 60,
    viewBox: "0 0 61 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.5 56.875C15.675 56.875 3.625 44.825 3.625 30C3.625 15.175 15.675 3.125 30.5 3.125C45.325 3.125 57.375 15.175 57.375 30C57.375 44.825 45.325 56.875 30.5 56.875ZM30.5 6.875C17.75 6.875 7.375 17.25 7.375 30C7.375 42.75 17.75 53.125 30.5 53.125C43.25 53.125 53.625 42.75 53.625 30C53.625 17.25 43.25 6.875 30.5 6.875Z",
    fill: "#33B61E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9501 38.95C26.4501 38.95 25.9751 38.75 25.6251 38.4L18.5501 31.325C17.8251 30.6 17.8251 29.4 18.5501 28.675C19.2751 27.95 20.4751 27.95 21.2001 28.675L26.9501 34.425L39.8001 21.575C40.5251 20.85 41.7251 20.85 42.4501 21.575C43.1751 22.3 43.1751 23.5 42.4501 24.225L28.2751 38.4C27.9251 38.75 27.4501 38.95 26.9501 38.95Z",
    fill: "#33B61E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessIcon);
export default __webpack_public_path__ + "static/media/success-icon.d31372b96ae625047ebf26cc5170f04f.svg";
export { ForwardRef as ReactComponent };